import { toVatLabelTransformer } from "shared/lib";

export const toVatCodesOptionsTransformer = (vatCodes) =>
  vatCodes?.map((vatCode) => ({
    value: vatCode.id,
    label: toVatLabelTransformer(vatCode),
  }));
